import { useState, useContext, useEffect } from "react";

import LocationContext from "@context/location/locationContext";

import { getCustomExtraPath } from "@pages/Dashboard/RevenueDashBoard/TotalSales/helper";

import CustomDataTable from "@shared-ui-components/CustomDataTable";
import Colors from "@src/constants/Colors";
import { useNavigate } from "react-router-dom";
import { getApiResponse } from "@src/utils/service";
import { SORTKEYMAP } from "@src/constants/DataTable";
import { message } from "@src/constants";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";
import { columns, refineData } from "./helper";
import { StyledBox, StyledRootBox, StyledTypography } from "./style";

const EmployeePayTable = ({ pagination }: { pagination: boolean }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [rowData, setRowsData] = useState([]);
  const navigate = useNavigate();

  const [pageNumber, setPageNumber] = useState(0);
  const [sortBy, setSortBy] = useState({
    tableName: "amt_act",
    label: "AMT $",
    order: "desc",
  });
  const [{ locationState }] = useContext(LocationContext);

  const { property, store, revenueCenter, date } = locationState;

  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);

  const filters = {
    property,
    store,
    rvc: revenueCenter,
    sortBy: "amt_act",
    date,
  };

  const filter = getCustomExtraPath(filters);

  const url = `labour-emp-pay${filter}&sort_by=${sortBy.tableName}&sort_order=${
    sortBy.order === "desc" ? "desc" : "asc"
  }&page=${pageNumber + 1}`;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage - 1);
  };

  const sortHandler = (sortkey: string) => {
    const sortKeyObject = SORTKEYMAP.find(
      (el) => el.tableName === sortkey.toLowerCase()
    );
    setSortBy((prev) => {
      if (sortKeyObject) {
        return {
          tableName: sortKeyObject.label,
          label: sortkey,
          order: prev.order === "desc" ? "asc" : "desc",
        };
      }
      return prev;
    });
  };

  const handleNavigate = () => {
    navigate("/labour-dashboard/employee-pay");
  };

  useEffect(() => {
    setPageNumber(0);
  }, [property, store, revenueCenter, date]);

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const { data, error } = await getApiResponse(url);
        if (data !== null) {
          const refinedData = refineData(data);
          setRowsData(refinedData);
          setIsLoading(false);
        } else {
          showErrorToastSetState({
            errorMessage: error || "",
            errorTitle: message.ERROR_MESSAGE_DASHBOARD,
            open: true,
          });
        }
        setIsLoading(false);
      } catch (err) {
        showErrorToastSetState({
          errorMessage: "",
          errorTitle: message.ERROR_MESSAGE_DASHBOARD,
          open: true,
        });
      }
    };
    getData();
  }, [url]);

  return (
    <StyledRootBox>
      <StyledBox>
        <StyledTypography color={Colors.primary}>Employee Pay</StyledTypography>
      </StyledBox>
      <CustomDataTable
        sortHandler={sortHandler}
        rowData={rowData}
        page={pageNumber}
        showPagination={pagination}
        sortBy={sortBy}
        handleNavigate={handleNavigate}
        handlePageChange={handleChangePage}
        isLoading={isLoading}
        dyColumns={columns}
      />
    </StyledRootBox>
  );
};

export default EmployeePayTable;
